// EmptyContent means a valid empty response. Transport/provider errors do not.
const resourceFailed = (resource) => resource?.content?.type === 'Err' &&
    resource.content.content?.type !== 'EmptyContent';

module.exports = resourceFailed;
